import { useQuery } from "@tanstack/react-query";
import fetcher from "../utils/fetcher";
const useMlsList = () => {
  return  useQuery({
    queryKey: ["mlsList"],
    queryFn: async () => {
      const resp = await fetcher({
        url: "/api/core/account/mls",
      });
      return resp.data;
    },
    staleTime: Infinity,
  });
};
export default useMlsList;
